var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#order-history_svg__clip0_400_4560)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 7a1 1 0 011-1h6a1 1 0 110 2h-6a1 1 0 01-1-1zM12 11a1 1 0 100 2h6a1 1 0 100-2h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 0a1 1 0 00-1 1v16H3a3 3 0 00-3 3v3a1 1 0 001 1h12a1 1 0 001-1v-2.583c0-.785.627-1.417 1.5-1.417.818 0 1.5.55 1.5 1.5a3.5 3.5 0 107 0V1a1 1 0 00-1-1H7zm8.5 17c1.77 0 3.5 1.299 3.5 3.5a1.5 1.5 0 103 0V2H8v15h7.5zM3 19a1 1 0 00-1 1v2h10v-1.583c0-.514.109-.992.303-1.417H3z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "order-history_svg__clip0_400_4560"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgOrderHistory;